import { Sprout } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function GardenComingSoon() {
  return (
    <div className="mx-auto max-w-2xl space-y-4 p-4 pb-24">
      <Card>
        <CardContent className="space-y-4 pt-8">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <Sprout className="h-8 w-8 text-primary" />
            </div>
            <h1 className="text-2xl font-semibold">Garden planner — coming soon</h1>
            <p className="text-sm text-muted-foreground">
              We're rebuilding this so it actually works for the way real
              gardens look from a phone camera.
            </p>
          </div>

          <div className="space-y-3 pt-2 text-sm">
            <p className="font-medium">What's coming:</p>
            <ul className="ml-5 list-disc space-y-1.5 text-muted-foreground">
              <li>
                Sketch your garden's top-down layout in a minute — beds,
                fences, paths, trees, sheds — with drag handles to move and
                resize.
              </li>
              <li>
                Personalized plant suggestions tailored to your hardiness zone,
                season, and what you actually like to cook.
              </li>
              <li>
                A planting schedule with weekly check-in reminders so nothing
                gets missed.
              </li>
              <li>
                Optional photo analyzer for rough distance measurements when
                you don't feel like sketching from scratch.
              </li>
            </ul>
          </div>

          <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-200">
            Want early access or have ideas for what should ship first? Tap the
            floating Feedback button on any page — those notes go straight to
            the team building this.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
